import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PageLayout from "../layout/PageLayout";
import {
  EditEvent,
  EventDetail,
  Events,
  UpcomingEvents,
  NewEvent,
  UserDetail,
  Users,
  EventTypes,
  FeaturedEventsOrder,
  DashboardRedirect,
  ReportsConfig,
  BenefitsMetricsDashboard,
  ActiveUsersDashboard,
  BenefitsMetricsDetail,
  Tenants,
  NewTenant,
  EditTenant,
  TenantDomains,
  BoUsers,
  SendPushNotifications,
  SendCustomMessages,
  PushHistory,
  PushNotificationDetail,
  PushNotificationsReport,
  InstitutionalCommunications,
  NewInstitutionalCommunication,
  EditInstitutionalCommunication,
  Venues,
  NewVenue,
  EditVenue,
  VenueDetail,
  Workshops,
  NewWorkshop,
  EditWorkshop,
  WorkshopDetail,
  WorkshopsSortOrder,
  PhotoReports,
  DeletedUsers,
  RulesConfig,
  FeatureFlagsConfig,
  AgentQueries,
  AgentExemplars,
  BenefitSettings,
  BenefitCategories,
  BenefitPartners,
  NewBenefitPartner,
  EditBenefitPartner,
  BenefitPartnerDetail,
  Benefits,
  NewBenefit,
  EditBenefit,
  BenefitDetail,
  SupportCategories,
  SupportArticles,
  SupportArticleNew,
  SupportArticleEdit,
  SupportFaqs,
  SupportContactReasons,
  SupportConfig,
  SupportFeedbackDashboard,
  SupportContacts,
  EventCancellationsHistory,
  DataTypesConfig,
  ShareSettingsConfig,
  HomeSectionsConfig,
  Banners,
  BannerEditor,
  Attendances,
  EventAttendance,
  PointMetrics,
  PointRules,
  PointRewards,
  PointRedemptions,
  PointLedger,
  PointSettings,
} from "../pages";
import { NewUser } from "../pages/Users/NewUser";
import { EditUser } from "../pages/Users/EditUser";
import AdminChat from "../pages/Chat/AdminChat";
import { EventListDV } from "../components/Dataviews/EventListDV";


const RouterApp = () => {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<PageLayout />}>
          <Route index element={<UpcomingEvents />} />
          <Route path="events" element={<Events />} />
          <Route path="events/featured-order" element={<FeaturedEventsOrder />} />
          <Route path="events/cancellations" element={<EventCancellationsHistory />} />
          <Route path="attendances" element={<Attendances />} />
          <Route path="attendances/toma" element={<EventAttendance />} />
          <Route path="events/:eventId" element={<EventDetail />} />
          <Route path="events/:eventId/edit" element={<EditEvent />} />
          <Route path="events/new" element={<NewEvent />} />
          <Route path="events/types" element={<EventTypes />} />
          <Route path="rules" element={<RulesConfig />} />
          <Route path="feature-flags" element={<FeatureFlagsConfig />} />
          <Route path="config/tipo-datos" element={<DataTypesConfig />} />
          <Route path="config/compartir" element={<ShareSettingsConfig />} />
          <Route path="config/home-sections" element={<HomeSectionsConfig />} />
          <Route path="config/home-banners" element={<Banners />} />
          <Route path="config/home-banners/new" element={<BannerEditor />} />
          <Route path="config/home-banners/:bannerId/edit" element={<BannerEditor />} />
          <Route path="users" element={<Users />} />
          <Route path="users/deleted" element={<DeletedUsers />} />
          <Route path="users/:userId" element={<UserDetail />} />
          <Route path="users/new" element={<NewUser />} />
          <Route path="users/edit/:userId" element={<EditUser />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="tenants/new" element={<NewTenant />} />
          <Route path="tenants/edit/:tenantId" element={<EditTenant />} />
          <Route path="tenants/:tenantId/domains" element={<TenantDomains />} />
          <Route path="bo-users" element={<BoUsers />} />
          <Route path="venues" element={<Venues />} />
          <Route path="venues/new" element={<NewVenue />} />
          <Route path="venues/:venueId" element={<VenueDetail />} />
          <Route path="venues/:venueId/edit" element={<EditVenue />} />
          <Route path="workshops" element={<Workshops />} />
          <Route path="workshops/sort-order" element={<WorkshopsSortOrder />} />
          <Route path="workshops/new" element={<NewWorkshop />} />
          <Route path="workshops/:workshopId" element={<WorkshopDetail />} />
          <Route path="workshops/:workshopId/edit" element={<EditWorkshop />} />
          <Route path="reportes" element={<ReportsConfig />} />
          <Route path="dashboard/" element={<DashboardRedirect />} />
          <Route path="benefits/metrics" element={<BenefitsMetricsDashboard />} />
          <Route path="activity/active-users" element={<ActiveUsersDashboard />} />
          <Route path="benefits/metrics/detail" element={<BenefitsMetricsDetail />} />
          <Route path="notifications/send" element={<SendPushNotifications />} />
          <Route path="notifications/custom-messages" element={<SendCustomMessages />} />
          <Route path="notifications/history" element={<PushHistory />} />
          <Route path="notifications/history/:id" element={<PushNotificationDetail />} />
          <Route path="reportes/notificaciones" element={<PushNotificationsReport />} />
          <Route
            path="institutional-communications"
            element={<InstitutionalCommunications />}
          />
          <Route
            path="institutional-communications/new"
            element={<NewInstitutionalCommunication />}
          />
          <Route
            path="institutional-communications/:communicationId/edit"
            element={<EditInstitutionalCommunication />}
          />
          <Route path="benefits-settings" element={<BenefitSettings />} />
          <Route path="benefits-categories" element={<BenefitCategories />} />
          <Route path="benefits-partners" element={<BenefitPartners />} />
          <Route path="benefits-partners/new" element={<NewBenefitPartner />} />
          <Route path="benefits-partners/:id" element={<BenefitPartnerDetail />} />
          <Route path="benefits-partners/:id/edit" element={<EditBenefitPartner />} />
          <Route path="benefits-catalog" element={<Benefits />} />
          <Route path="benefits-catalog/new" element={<NewBenefit />} />
          <Route path="benefits-catalog/:id" element={<BenefitDetail />} />
          <Route path="benefits-catalog/:id/edit" element={<EditBenefit />} />
          <Route path="points/metrics" element={<PointMetrics />} />
          <Route path="rules/points" element={<PointRules />} />
          <Route path="points/rewards" element={<PointRewards />} />
          <Route path="points/redemptions" element={<PointRedemptions />} />
          <Route path="points/ledger" element={<PointLedger />} />
          <Route path="points/settings" element={<PointSettings />} />
          <Route path="chat" element={<AdminChat />} />
          <Route path="moderation/photo-reports" element={<PhotoReports />} />
          <Route path="test-events" element={<EventListDV />} />
          <Route path="agents/queries" element={<AgentQueries />} />
          <Route path="agents/exemplars" element={<AgentExemplars />} />
          <Route path="soporte/categorias" element={<SupportCategories />} />
          <Route path="soporte/articulos" element={<SupportArticles />} />
          <Route path="soporte/articulos/nuevo" element={<SupportArticleNew />} />
          <Route path="soporte/articulos/:id" element={<SupportArticleEdit />} />
          <Route path="soporte/faqs" element={<SupportFaqs />} />
          <Route path="soporte/motivos" element={<SupportContactReasons />} />
          <Route path="soporte/configuracion" element={<SupportConfig />} />
          <Route path="soporte/feedback" element={<SupportFeedbackDashboard />} />
          <Route path="soporte/contactos" element={<SupportContacts />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default RouterApp;
